import { ProtectedRoute } from "common/components/ProtectedRoute";
import { urls } from "common/urls";
import { AdminPage } from "domain/admin/pages/AdminPage";
import { ArticleAdminPage } from "domain/admin/pages/ArticleAdminPage";
import { AutoGenerateSimulation } from "domain/admin/pages/AutoGenerateSimulation";
import { ExamEditPage } from "domain/admin/pages/ExamEditPage";
import { ExamSyllabusAdminPage } from "domain/admin/pages/ExamSyllabusAdminPage";
import { FolderAdminPage } from "domain/admin/pages/FolderAdminPage";
import { FolderEditPage } from "domain/admin/pages/FolderEditPage";
import { KurssloeyfeAdminPage } from "domain/admin/pages/KurssloeyfeAdminPage";
import { KurssloeyfeEditPage } from "domain/admin/pages/KurssloeyfeEditPage";
import { MultipleChoice } from "domain/admin/pages/MultipleChoice";
import { MultipleChoiceEditPage } from "domain/admin/pages/MultipleChoiceEditPage";
import { SimulationAdminPage } from "domain/admin/pages/SimulationAdminPage";
import { StudyProgrammeAdminPage } from "domain/admin/pages/StudyProgrammeAdminPage";
import { StudyProgrammeEditPage } from "domain/admin/pages/StudyProgrammeEditPage";
import { SimulationDiagnosisAdminPage } from "domain/admin/simulation/SimulationDiagnosisAdminPage";
import { SimulationEditPage } from "domain/admin/simulation/SimulationEditPage";
import React from "react";
import { Route, Routes } from "react-router-dom";

export const AdminRoutes: React.FC = () => (
  <Routes>
    <Route
      path={urls.admin}
      element={
        <ProtectedRoute
          element={<AdminPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.studyProgrammeAdminOverview}
      element={
        <ProtectedRoute
          element={<AdminPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    {[
      urls.studyProgrammeAdmin(":studyProgrammeId"),
      urls.studyProgrammeAdminExams(":studyProgrammeId"),
    ].map((path) => (
      <Route
        key={path}
        path={path}
        element={
          <ProtectedRoute
            element={<StudyProgrammeAdminPage />}
            authz={(auth) => auth.me?.menu.admin === true}
          />
        }
      />
    ))}
    <Route
      path={urls.studyProgrammeAdminEdit(":studyProgrammeId")}
      element={
        <ProtectedRoute
          element={<StudyProgrammeEditPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.examAdmin(":examSyllabusId")}
      element={
        <ProtectedRoute
          element={<ExamSyllabusAdminPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.examAdminEdit(":examId")}
      element={
        <ProtectedRoute
          element={<ExamEditPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.folderAdmin(":folderId")}
      element={
        <ProtectedRoute
          element={<FolderAdminPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.folderAdminEdit(":folderId")}
      element={
        <ProtectedRoute
          element={<FolderEditPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.assignmentAdmin(":multipleChoiceId")}
      element={
        <ProtectedRoute
          element={<MultipleChoice />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.assignmentAdminEdit(":multipleChoiceId")}
      element={
        <ProtectedRoute
          element={<MultipleChoiceEditPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.kurssloeyfeAdmin(":kurssloeyfeId")}
      element={
        <ProtectedRoute
          element={<KurssloeyfeAdminPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.kurssloeyfeAdminEdit(":kurssloeyfeId")}
      element={
        <ProtectedRoute
          element={<KurssloeyfeEditPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.simulationAdminOverview}
      element={
        <ProtectedRoute
          element={<SimulationAdminPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.simulationCaseAdmin(":simulationCaseId")}
      element={
        <ProtectedRoute
          element={<SimulationEditPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.simulationDiagnosisAdmin(":simulationCaseId")}
      element={
        <ProtectedRoute
          element={<SimulationDiagnosisAdminPage />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    <Route
      path={urls.simulationCaseGenerate(":simulationCaseId")}
      element={
        <ProtectedRoute
          element={<AutoGenerateSimulation />}
          authz={(auth) => auth.me?.menu.admin === true}
        />
      }
    />
    {[urls.articleAdmin(":articleId"), urls.articleAdminEdit(":articleId")].map(
      (path) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute
              element={<ArticleAdminPage />}
              authz={(auth) => auth.me?.menu.admin === true}
            />
          }
        />
      ),
    )}
  </Routes>
);
